/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscountRequest } from '../../models/article-discount-request';

export interface AddDiscountToArticle$Params {
  id: number;
  articleId: number;
      body: ArticleDiscountRequest
}

export function addDiscountToArticle(http: HttpClient, rootUrl: string, params: AddDiscountToArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addDiscountToArticle.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('articleId', params.articleId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addDiscountToArticle.PATH = '/offers/{id}/articles/{articleId}/discounts';
